// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"18fa8f9a","885":"ceca9173"}[chunkId] + ".chunk.js";
};